import '../../assets/beautrium-css/calltoaction.scss'

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { getActiveLanguage } from 'react-localize-redux';
import { getStrapiAPI } from '../../assets/strapi';

class CallToAction extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: []
        };
    }

    componentDidMount() {
        getStrapiAPI('call-to-action')
            .then(response => {
                this.setState({ data: get(response, 'data.columns', []) });
            })
            .catch(error => {
                console.error('Error fetching call to action data:', error);
            });
    }


    render() {
        const { currentLanguage } = this.props;
        const { data } = this.state;
        return (
            <section key="callToAction" className="container-fluid calltoaction">
                <div className="container px-0">
                    <div className="row">
                        {data.map((item, index) => (
                            <div key={index} className="col-2 icon">
                                <div><img src={item.icon.url} alt={item.text_th} /></div>
                                <span className="desc">
                                    {currentLanguage === 'th' ? item.text_th : (item.text_en || item.text_th)}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        );
    }
}

function mapStateToProps(state) {
    return {
        currentLanguage: getActiveLanguage(state.locale).code,
    }
}

export default connect(mapStateToProps, { getActiveLanguage })(CallToAction);